import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
import formatDate from "../utils/formatDate";

const LeavesHistory = ({ refreshKey }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedIndex, setExpandedIndex] = useState(null);

  const fetchHistory = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${BASE_URL}/api/dcr-leave-assignments/bulk-history`,
        { headers: getAuthHeaders() },
      );
      setHistory(res.data.data);
    } catch (error) {
      console.error("Error fetching history:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, [refreshKey]);

  return (
    <div className="p-6 bg-gray-50 rounded-lg shadow-md">
      <h1 className="text-3xl font-bold mb-6 text-blue-600 text-center">
        History
      </h1>

      {loading ? (
        <div className="text-center text-gray-500">Loading...</div>
      ) : (
        <div className=" bg-white shadow-lg">
          <table className="unlock-dcr-leave-table min-w-full text-sm text-left">
            <thead className="bg-indigo-600 text-white">
              <tr>
                <th className="px-4 py-3">Emp ID</th>
                <th className="px-4 py-3">Employee Name</th>
                <th className="px-4 py-3">Leave Type</th>
                <th className="px-4 py-3">Start Date</th>
                <th className="px-4 py-3">End Date</th>
                <th className="px-4 py-3">Remarks</th>
                <th className="px-4 py-3">Applied On</th>
                <th className="px-4 py-3">Updated By</th>
                <th className="px-4 py-3 text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              {history.map((group, index) => (
                <tr
                  key={index}
                  className="border-b hover:bg-gray-50 transition"
                >
                  <td className="px-4 py-3 font-medium text-gray-700">
                    {group.records?.map((r) => (
                      <div key={r.id}>{r.employee}</div>
                    ))}
                  </td>

                  {/* Employee Names */}
                  <td className="px-4 py-3">
                    {group.records?.map((r) => (
                      <div key={r.id}>{r.employee_name}</div>
                    ))}
                  </td>
                  {/* Leave Type (assuming same for bulk) */}
                  <td className="px-4 py-3">
                    {group.records[0]?.leave_type_name}
                  </td>

                  {/* Start Date */}
                  <td className="px-4 py-3">
                    {formatDate(group.records[0]?.start_date)}
                  </td>

                  {/* End Date */}
                  <td className="px-4 py-3">
                    {formatDate(group.records[0]?.end_date)}
                  </td>

                  {/* Remarks */}
                  <td className="px-4 py-3">
                    {group.records[0]?.remarks || "-"}
                  </td>

                  {/* Applied On */}
                  <td className="px-4 py-3">{formatDate(group.created_at)}</td>

                  {/* Updated By */}
                  <td className="px-4 py-3">{group.updated_by || "-"}</td>

                  {/* Status */}
                  <td className="px-4 py-3 text-center">
                    {group.is_deleted ? (
                      <span className="bg-red-100 text-red-600 px-3 py-1 rounded-full text-xs font-semibold">
                        Deleted ({group.total_records})
                      </span>
                    ) : (
                      <span className="bg-green-100 text-green-600 px-3 py-1 rounded-full text-xs font-semibold">
                        Applied ({group.total_records})
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {history.length === 0 && (
            <div className="text-center p-6 text-gray-500">
              No history found.
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LeavesHistory;
